<script setup lang="ts">
import { mediaUrl } from '#imports'

export interface BingoFactsProps {
    items?: string[]
}

const props = defineProps<BingoFactsProps>()
</script>

<template>
    <div class="bingo__facts">
        <ul class="usps">
            <li
                v-for="(factText, index) in props.items"
                :key="index"
            >
                <UIIcon name="check" size="27" />
                <!-- eslint-disable-next-line vue/no-v-html factText is safe -->
                <span v-html="factText" />
            </li>
        </ul>

        <slot name="cta" />

        <figure class="bingo__balls bingo__balls--bottom">
            <NuxtImg
                class="bingo__ball--blue"
                preset="local"
                provider="cloudflare"
                loading="lazy"
                decoding="async"
                :src="mediaUrl('/media/bingo/ball-blue.png')"
                sizes="96px md:156px lg:220px"
                alt="Bingo ball blue"
                width="110"
                height="110"
                quality="70"
            />
            <NuxtImg
                class="bingo__ball--yellow"
                preset="local"
                provider="cloudflare"
                loading="lazy"
                decoding="async"
                :src="mediaUrl('/media/bingo/ball-yellow.png')"
                sizes="50px md:60px lg:110px"
                alt="Bingo ball yellow"
                width="60"
                height="60"
                quality="70"
            />
        </figure>
    </div>
</template>

<style lang="scss">
.bingo__facts {
    position: relative;
    margin: 20px 0 15px;
    padding: 15px;
    background: $bingo-box-bg-color;
    font-size: pixel-to-vw(18, 360);
    font-weight: $bingo-facts-weight;
    border-radius: var(--border-radius-lg, $border-radius-lg);

    @media (min-width: $screen-md) {
        max-width: 54vw;
        padding: 20px;
        font-size: 23px;
    }

    @media (min-width: $screen-lg) {
        width: 510px;
        margin: 30px 40px 0 0;
    }

    ul {
        padding: 0;
        list-style: none;

        @media (min-width: $screen-md) {
            margin-bottom: 25px;
        }
    }

    li {
        display: flex;
        align-items: center;
        margin-bottom: 15px;

        @media (min-width: $screen-lg) {
            margin-bottom: 25px;
        }

        &:last-child {
            margin-bottom: 0;
        }
    }

    em {
        color: $bingo-yellow;
        font-style: normal;
    }

    .icon {
        .bingo--90 & {
            background-color: $bingo-green;
        }
    }
}

.usps {
    li > .icon {
        align-items: center;
        width: 27px;
        height: 27px;
        margin-right: 7px;
        border-radius: 50%;
        color: $on-cta;
        background: $cta-bg center no-repeat;

        @media (min-width: $screen-lg) {
            width: 36px !important; //Overwrite UIIcon size
            height: 36px;
            margin-right: 10px;
        }

        svg {
            width: 54%;
            height: 54%;
        }
    }
}
</style>
